export const TOUR_STEPS = [
    {
        id: 'welcome',
        title: 'Welcome to LandScope',
        body: 'In the next 60 seconds, you’ll see how to open a project, read the terrain, and start your first map. You can replay this anytime from Help & Support.',
    },
    {
        id: 'my-projects',
        target: 'my-projects',
        title: 'Your projects',
        body: 'Every map you create or unlock lives here. Click any project to load it on the map and pick up where you left off.',
    },
    {
        id: 'project-structure',
        target: 'project-structure',
        title: 'Layers & folders',
        body: 'This is where an open project’s layers live. Toggle them on and off to see slope, water, access, and more. Click “?” on any layer for a quick explanation.',
    },
    {
        id: 'demo-projects',
        target: 'demo-projects',
        title: 'Explore a sample project',
        body: 'Start here. Open a sample project to see a real property with contours, drainage, and access already mapped. It’s the fastest way to see what LandScope can do.',
    },
    {
        id: 'create-project',
        target: 'create-project',
        title: 'Start your own project',
        body: 'Ready to map your area of interest? Click “Create Project” to get started. Your first demonstration project is free for 7 days. Instant access is available across the US, Canada, the UK, Ireland, New Zealand, the Netherlands, France, Switzerland, Norway, Austria, Portugal and Uruguay — turn on the coverage layer to check yours.',
    },
    {
        id: 'help-hub',
        target: 'help-hub',
        title: 'We’re here for you',
        body: 'Stuck or curious? Open Help & Support for the layer guide, short tutorials, and a direct way to reach us.',
    },
    {
        id: 'finish',
        title: 'Ready to dive in',
        body: 'Step 1: Open a sample project to see LandScope in action. Step 2: Create your own project when you’re ready. Welcome aboard.',
    },
];
